import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import { Input } from 'modules/form/index';

const Label = styled(Text)`
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  z-index: 24;
  background: ${COLORS.WHITE};
  padding: 0 4px;
  top: -2px;
  left: 12px;
  font-size: 12px;
  text-transform: capitalize;
`;

const Root = styled.div`
  position: relative;
`;

const CustomInputDate = styled(Input)`
  border-radius: 8px;
  width: 100%;
  border: 1px solid ${COLORS.GHOST};
`;

export default function CueCalenderInput({
  label,
  onClick,
  required,
  value,
  min,
  max,
  onChange,
  width,
}) {
  return (
    <Root>
      <Label variant="body3" color={COLORS.SCORPION}>
        {label}
      </Label>
      <CustomInputDate
        type="date"
        width={width}
        required={required}
        value={value || ''}
        min={min}
        max={max}
        onChange={onChange}
      />
    </Root>
  );
}
